import React, { FC, useState } from 'react';
import styled from '@emotion/styled';
import { Button, Input, InputType, Modal, pxToRem } from '@modernhealth/vital-components';
import { useTranslation } from 'react-i18next';
import { toastNotificationsService, userService } from 'src/config/rootService';
import { captureException } from '@sentry/browser';

interface ContactSupportProps {
    isVisible: boolean;
    onModalClose: VoidFunction;
}

export const ContactSupportModal: FC<ContactSupportProps> = ({ onModalClose, isVisible }) => {
    const { t } = useTranslation();
    const [text, setText] = useState<string>('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        onModalClose();
        setText('');
        setLoading(false);
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await userService.submitHelpDeskRequest(text, ['member_support_claims_hpi_support']);
            toastNotificationsService.renderSuccessToast(
                t('payments:contact_support_modal.success_message'),
            );
            handleClose();
        } catch (err) {
            // toast error handled in userService.submitHelpDeskRequest
            captureException(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <Modal
                maxWidth={600}
                isVisible={isVisible}
                onCloseButtonClick={handleClose}
                title={t('dependents:support_modal.title')}
                description={t('dependents:support_modal.description')}
            >
                <Content>
                    <Input
                        fieldId="support_question"
                        type={InputType.TextArea}
                        label={t('dependents:support_modal.placeholder')}
                        onChange={(value: string) => setText(value)}
                        value={text}
                        useDefaultPlaceholder
                        height={300}
                    />
                    <Button
                        fluid
                        size="large"
                        onClick={() => handleSubmit()}
                        style={{ marginTop: 24 }}
                        disabled={text === '' || loading}
                    >
                        {t('dependents:support_modal.submit')}
                    </Button>
                </Content>
            </Modal>
        </Container>
    );
};

const Container = styled.div({
    'div[class*="content"]': {
        borderRadius: 0,
    },
});

const Content = styled.div({
    marginTop: pxToRem(17),
});
